module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/lim/example_lim.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/lim/example_lim.png
// module id = 587
// module chunks = 0